module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"KPILoadingError":"Error loading one or more KPIs","loading":"Loading..."},"es":{"KPILoadingError":"Error cargando uno o más indicadores","loading":"Cargando..."}}')
  delete Component.options._Ctor
}
